export enum FrequencyCheckEnum {
  ANNUAL = 'annual',
  SEMI_ANNUAL = 'semi-annual',
  QUARTERLY = 'quarterly'
}

